import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { NhaCungCapPhien } from './auth/PhienDangNhap';
import { NhaCungCapThongBao } from './components/ThongBao';
import { DaiBanThu } from './components/DaiBanThu';
import './theme/base.css';
import './theme/dashboard-pancake.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (soLan, loi) => {
        // Không thử lại khi bị từ chối quyền hoặc hết phiên.
        const status = (loi as { status?: number }).status;
        if (status === 401 || status === 403) return false;
        return soLan < 2;
      },
      refetchOnWindowFocus: false,
      /**
       * Tự tải lại số liệu mỗi 15 phút — BOSS yêu cầu 23/09/2026.
       *
       * Dùng `refetchInterval` của react-query chứ KHÔNG reload cả trang: tải
       * lại trang sẽ mất chỗ đang cuộn, mất ô đang gõ dở và bắt đăng nhập lại
       * hiển thị. Cách này chỉ gọi lại API rồi thay số, người dùng đang xem
       * không bị gián đoạn.
       *
       * `refetchIntervalInBackground: false` — tab đang ẩn thì ngưng gọi, mở
       * lại mới gọi tiếp, đỡ đập vào API Pancake/MISA khi không ai xem.
       */
      refetchInterval: 15 * 60 * 1000,
      refetchIntervalInBackground: false,
    },
  },
});

const goc = document.getElementById('root');
if (!goc) throw new Error('Không tìm thấy #root trong index.html');

createRoot(goc).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <NhaCungCapThongBao>
          <DaiBanThu />
          <NhaCungCapPhien>
            <App />
          </NhaCungCapPhien>
        </NhaCungCapThongBao>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
